import { produce } from 'immer';
import { GlobalStore as G } from 'types/store';
import { StoreActionTypes as A } from 'store/reducer';

const action = (f: (g: G, a: A) => void) => (a: A) => (g: G) => produce(f)(g, a);

export default action;
